//#region src/modules/shared/constants.ts
var SEARCH_FILTER_FILTER_LABELS = /* @__PURE__ */ function(SEARCH_FILTER_FILTER_LABELS) {
	SEARCH_FILTER_FILTER_LABELS["ACTIVITY_TYPE"] = "activityType";
	SEARCH_FILTER_FILTER_LABELS["AUTHOR"] = "author";
	SEARCH_FILTER_FILTER_LABELS["ENTRY_TYPE"] = "entryType";
	SEARCH_FILTER_FILTER_LABELS["EVENT_TYPE"] = "eventType";
	SEARCH_FILTER_FILTER_LABELS["EVENT_REF"] = "eventRef";
	SEARCH_FILTER_FILTER_LABELS["LOCATION"] = "location";
	SEARCH_FILTER_FILTER_LABELS["LOCATION_REF"] = "locationRef";
	SEARCH_FILTER_FILTER_LABELS["RECORD_REF"] = "recordRef";
	SEARCH_FILTER_FILTER_LABELS["REPORT_TYPE"] = "reportType";
	SEARCH_FILTER_FILTER_LABELS["SCOPE"] = "scope";
	SEARCH_FILTER_FILTER_LABELS["USER"] = "user";
	SEARCH_FILTER_FILTER_LABELS["USER_REF"] = "userRef";
	return SEARCH_FILTER_FILTER_LABELS;
}({});
//#endregion
export { SEARCH_FILTER_FILTER_LABELS };

//# sourceMappingURL=constants.js.map